import styled from 'styled-components';
import { Button } from '@user-portal/wikr-components';

import { color } from '../../../theme/selectors';

export const Img = styled.img`
    margin: 30px auto 12px;
    display: block;
`;

export const ConfirmButton = styled(Button)`
    border: 1px solid ${color('border-default')};
    padding: 20px;
    color: ${color('border-default')};
    max-width: 100%;

    &&& {
        background-color: transparent;
    }

    &:hover {
        background-color: ${color('surface-hovered')} !important;
        color: ${color('surface-hovered')} !important;
    }
`;
